import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import cx from 'classnames';
import classes from 'app/components/Form/Autocomplete/AutocompleteSingle/AutocompleteSingle.module.scss';
import { getColorFromBackground } from 'app/libs/helpers/getColorFromBackground.js';
import { cyLabelFormater } from 'app/libs/helpers/cyTools.js';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
import { toHighlightJSX } from 'app/libs/helpers/toHighlightJSX.jsx';
import { colors } from 'app/styles/vars.js';
import usePinnedOptions from 'app/pages/Project/ProductionManagement/FollowUp/usePinnedOptions';
const Option = (props) => {
    const { value, label, labelCustom, backgroundColor, color, onClick, onMouseDown, disabled, highlighted, icon, selected, separator, animeKeyPressed, pinnable, isPinned, } = props;
    const [pinnedOptions, setPinnedOptions] = usePinnedOptions();
    const [shift, setShift] = useState(false);
    const [ctrl, setCtrl] = useState(false);
    const [meta, setMeta] = useState(false);
    useEffect(() => {
        document.addEventListener('keydown', setOnKeyDown, false);
        document.addEventListener('keyup', setOnKeyUp, false);
        return () => {
            document.removeEventListener('keydown', setOnKeyDown, false);
            document.removeEventListener('keyup', setOnKeyUp, false);
        };
    }, []);
    const setOnKeyDown = (event) => {
        if (event.shiftKey)
            setShift(true);
        if (event.ctrlKey)
            setCtrl(true);
        if (event.metaKey)
            setMeta(true);
    };
    const setOnKeyUp = (event) => {
        if (!event.shiftKey)
            setShift(false);
        if (!event.ctrlKey)
            setCtrl(false);
        if (!event.metaKey)
            setMeta(false);
    };
    const togglePinnedOption = (event) => {
        event.stopPropagation();
        if (!props.value)
            return;
        const newOptions = pinnedOptions.includes(props.value)
            ? pinnedOptions.filter((opt) => opt !== props.value)
            : [...pinnedOptions, props.value];
        setPinnedOptions(newOptions);
    };
    if (separator) {
        return (_jsxs("div", { className: "relative", tabIndex: -1, children: [_jsx("div", { style: {
                        width: '100%',
                        backgroundColor: 'rgba(0,0,0,0.08)',
                        height: 1,
                        margin: label ? '8px 0 6px 0' : undefined,
                    } }), label ? (_jsx("div", { className: "fontSize10 absolute", style: {
                        lineHeight: '11px',
                        top: -5,
                        left: 5,
                        backgroundColor: '#ffffff',
                        color: 'rgba(0,0,0,0.5)',
                        padding: '0 3px',
                    }, children: label })) : null] }));
    }
    return (_jsxs("div", { "data-item-value": value, "data-testid": cyLabelFormater('option', value || labelCustom || label), className: cx(classes.searchResultsItem, {
            [classes.disabled]: disabled,
            [classes.highlighted]: highlighted,
            [classes.hasBackgroundColor]: !!backgroundColor,
            [classes.shiftPressed]: (animeKeyPressed === null || animeKeyPressed === void 0 ? void 0 : animeKeyPressed.shift) && shift,
            [classes.ctrlPressed]: (animeKeyPressed === null || animeKeyPressed === void 0 ? void 0 : animeKeyPressed.ctrl) && ctrl,
            [classes.metaPressed]: (animeKeyPressed === null || animeKeyPressed === void 0 ? void 0 : animeKeyPressed.meta) && meta,
        }), onClick: !disabled ? onClick : null, onMouseDown: onMouseDown, style: {
            backgroundColor: disabled ? '#fff' : backgroundColor || '#ffffff',
            color: color || (backgroundColor ? getColorFromBackground(backgroundColor) : 'initial'),
            fontWeight: backgroundColor ? 'bold' : 'initial',
        }, children: [selected && (_jsx("div", { style: { width: 20 }, children: _jsx(FontIcon, { icon: "check", style: { fontSize: 14 } }) })), _jsxs("div", { className: "flex row alignCenter spaceBetween fullWidth", style: { paddingLeft: selected ? 10 : undefined }, children: [_jsxs("div", { className: "flex alignCenter", children: [icon ? _jsx(FontIcon, { icon: icon, className: "marginRight5", "data-testid": `option-${value}-type-icon` }) : null, _jsx("span", { style: { whiteSpace: 'pre' }, children: toHighlightJSX(labelCustom || label) })] }), _jsx("div", { style: { padding: '0 5px' }, onClick: togglePinnedOption, children: pinnable ? (_jsx(FontIcon, { icon: "fas-thumbtack", className: "marginLeft5", "data-testid": `option-${value}-pinned-icon`, style: {
                                color: isPinned ? colors.yuzuPrimaryColor : colors.grey,
                                transform: 'rotate(45deg)',
                            } })) : null })] })] }));
};
export default Option;
